<script setup>
  import { ref, computed } from "vue";
  import Popup from '@/components/controls/Popup.vue';
  import Icon from '@/components/icons/Icon.vue';

  const emit = defineEmits('sortOrder:change')

  const props = defineProps({
    id: {
      type: String,
      default: () => `sort-order-selector-${Date.now()}`
    },
    excludeOptions: {
      type: Array,
      default: () => []
    },
    useDefaultOption: {
      type: Boolean,
      default: false
    },
    surface: {
      type: Number,
      default: () => 1 
    }
  })

  const sortOrderDefaultOptions = {
    windspeed: 'Wind Speed',
    rank: 'Rank',
    userdefined: 'User Defined' ,
    name: 'Alphabetical',
    provider: 'Provider',
    distance: 'Distance'
  };

  const selectedSortOrder = defineModel({ required: true });

  const showMenu = ref(false);

  const sortOrderOptions = computed(() => {
    let options = {...sortOrderDefaultOptions}
    
    props.excludeOptions.forEach(option => delete options[option])

    if (props.useDefaultOption) {
      options = {'default': 'Default', ...options}
    }

    return options;
  })

  const sortOrderValues = computed(() => Object.keys(sortOrderOptions.value));  

  function handleOptionSelected(option) {
    selectedSortOrder.value = option;
    showMenu.value = false;
    const name = sortOrderDefaultOptions[option]

    emit('sortOrder:change', {option, name});
  }
</script>

<template>
  <Popup
    :id="props.id"
    positionY="bottom"
    positionX="center"
    v-model="showMenu"
  >
    <template #button-content>
      <div
        class="jwx-dropdown-control"
        type="button"
        :data-control-surface="props.surface"
      >
        <Icon name="up-down-arrows" class="jwx-dropdown-control__icon" />
        <p class="jwx-dropdown-control__label">{{ sortOrderOptions[selectedSortOrder] }}</p>
        <Icon name="chevron-up-down" class="jwx-dropdown-control__action-icon" />
      </div>
    </template>
    <template #menu-content>
      <div class="jwx-popup-menu">
        <div class="jwx-action-menu">
            <ul class="jwx-action-menu__list">
              <li 
                v-for="sortOrder in sortOrderValues"
                :key="sortOrder"
                class="jwx-action-menu__action"
              >
              <button
                @click.prevent="handleOptionSelected(sortOrder)"
                :data-sort-order="sortOrder"
                :data-selected="sortOrder === selectedSortOrder"
                class="jwx-action-menu__action-button"
              >
                <div class="jwx-action-menu__action-label">{{ sortOrderOptions[sortOrder] }}</div>
              </button>
              </li>
            </ul>
          </div>
      </div>
    </template>
  </Popup>
</template>